import { render, staticRenderFns } from "./HealthcareLogo.vue?vue&type=template&id=01999f7e&scoped=true&"
import script from "./HealthcareLogo.vue?vue&type=script&lang=js&"
export * from "./HealthcareLogo.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareLogo.vue?vue&type=style&index=0&id=01999f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01999f7e",
  null
  
)

export default component.exports